import React, { useState } from 'react';
import AddCharge from '../AddEdit/AddCharge';
import EditCharge from '../AddEdit/EditCharge';

const ChargesTab = () => {
    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = () => setShowEdit(true);

    return (
        <>
            <div className="row border-bottom-2 pb-3">
                <div className="col-md-12">
                    <div className="card px-3 py-2">
                        <div className="row">
                        <table className="table" style={{ borderCollapse: 'collapse' }}>
    <thead>
    <tr>
    <th colSpan="2" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Particulars</th>
    <th colSpan="4" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Revenue</th>
    <th colSpan="4" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Cost</th>
</tr>

        <tr>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Charge Head</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Curr.</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount (INR)</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>P/C</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Curr.</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount (INR)</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>P/C</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td >Air Export Freight</td>
            <td >INR</td>
            <td >0.00</td>
            <td >0.00</td>
            <td >P</td>
            <td >INR</td>
            <td >0.00</td>
            <td >0.00</td>
            <td >P</td>
        </tr>
    </tbody>
</table>

                        </div>
                    </div>
                </div>
            </div>
            <div className="py-2">
                <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                    <button className="btn btn-primary text-xs" type="button" onClick={handleShowAdd}>
                        New
                    </button>
                    <button className="btn btn-primary text-xs" type="button" onClick={handleShowEdit}>
                        Edit
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Delete
                    </button>
                </div>
            </div>

            {showAdd && <AddCharge showAdd={showAdd} handleCloseAdd={handleCloseAdd} />}
            {showEdit && <EditCharge showEdit={showEdit} handleCloseEdit={handleCloseEdit} />}
        </>
    );
};

export default ChargesTab;
